var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found-container"},[_c('div',{staticClass:"not-found-text"},[_vm._v("\n    No hemos encontrado ningún resultado"),_c('br')]),_c('div',{staticClass:"not-found-img"},[_c('img',{attrs:{"src":require("@/assets/no-items.svg"),"alt":""}})])])
}]

export { render, staticRenderFns }